import React, { Component, createContext } from "react";
import { firestore } from "../firebase";
import Helper from "../components/helper";

export const PLANITEM_N2A_CONTEXT = createContext();

class PlanItemN2AProvider extends Component {
  state = { n2a_planItems: undefined };

  unsubscribe = null;

  getShortDetailPrefix = value => {
    if (typeof value !== "string" || value.trim() === "") {
      return "";
    }

    return value.split("-")[0];
  };

  subscribeToBranch = () => {
    this.unsubscribe = firestore.collection(Helper.getBranchCollectionName("containers", this.props.branchCode))
      .where("state", "==", "a")
      .onSnapshot(snapshot => {
        const containerObjs = snapshot.docs.map(doc => {
          return { id: doc.id, routingContainerState: "n2a", ...doc.data() };
        });

        let notInvoicedList = containerObjs.filter(function (obj) {
          return obj.invoiced !== true;
        });

        notInvoicedList.sort(function (a, b) {
          const aDate = a.apptDate && typeof a.apptDate.toDate === "function" ? a.apptDate.toDate() : null;
          const bDate = b.apptDate && typeof b.apptDate.toDate === "function" ? b.apptDate.toDate() : null;
          const aDateKey = aDate ? `${aDate.getFullYear()}-${aDate.getMonth() + 1}-${aDate.getDate()}` : "";
          const bDateKey = bDate ? `${bDate.getFullYear()}-${bDate.getMonth() + 1}-${bDate.getDate()}` : "";

          if (aDateKey !== "" && aDateKey === bDateKey) {
            return this.getShortDetailPrefix(a.shortDetail).localeCompare(this.getShortDetailPrefix(b.shortDetail));
          }
          return Helper.compareDateLike(a.apptDate, b.apptDate);
        }.bind(this));

        this.setState({ n2a_planItems: notInvoicedList });
      });
  };

  componentDidMount = () => {
    this.subscribeToBranch();
  };

  componentDidUpdate = prevProps => {
    if ((prevProps.branchCode || "NY") !== (this.props.branchCode || "NY")) {
      if (this.unsubscribe) {
        this.unsubscribe();
      }
      this.setState({ n2a_planItems: undefined }, this.subscribeToBranch);
    }
  };

  componentWillUnmount = () => {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  };

  render() {
    const { n2a_planItems } = this.state;
    const { children } = this.props;

    return <PLANITEM_N2A_CONTEXT.Provider value={n2a_planItems}>{children}</PLANITEM_N2A_CONTEXT.Provider>;
  }
}

export default PlanItemN2AProvider;

PlanItemN2AProvider.defaultProps = {
  branchCode: "NY",
};
